import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Attribute, CreateAttributeRequest } from 'services/bidAnalysis/bidAnalysisServices';
import classes from '../ReferenceTables.module.scss';

interface AttributeModalProps {
  visible: boolean;
  onHide: () => void;
  onSave: () => void;
  editingAttribute: Attribute | null;
  attributeForm: CreateAttributeRequest;
  onFormChange: (form: CreateAttributeRequest) => void;
  saving?: boolean;
}

export const AttributeModal = ({
  visible,
  onHide,
  onSave,
  editingAttribute,
  attributeForm,
  onFormChange,
  saving = false,
}: AttributeModalProps) => {
  return (
    <Dialog
      header={editingAttribute ? 'Edit Attribute' : 'Create Attribute'}
      visible={visible}
      style={{ width: '500px' }}
      onHide={onHide}
      footer={
        <div>
          <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={onHide}
            className="p-button-text"
            disabled={saving}
          />
          <Button
            label={editingAttribute ? 'Update' : 'Create'}
            icon={saving ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
            onClick={onSave}
            className={classes.primaryButton}
            loading={saving}
            disabled={saving}
          />
        </div>
      }
    >
      <div className={classes.formContent}>
        <div className={classes.formField}>
          <label htmlFor="attribute_name">Attribute Name *</label>
          <InputText
            id="attribute_name"
            value={attributeForm.attribute_name}
            onChange={e => onFormChange({ ...attributeForm, attribute_name: e.target.value })}
            placeholder="Enter attribute name"
            className={classes.inputField}
          />
        </div>
        <div className={classes.formField}>
          <label htmlFor="attribute_description">Attribute Description *</label>
          <InputText
            id="attribute_description"
            value={attributeForm.attribute_description}
            onChange={e => onFormChange({ ...attributeForm, attribute_description: e.target.value })}
            placeholder="Enter attribute description"
            className={classes.inputField}
          />
        </div>
      </div>
    </Dialog>
  );
};

